import { Component, Input, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { Error } from '../errors/error/error';
import { Errors } from '../errors/errors';

@Component({
    selector: 'stby-form-control-errors',
    templateUrl: './form-control-errors.html',
    imports: [Errors, Error, TranslatePipe],
})
export class FormControlErrors {
    @Input() formControlItem: AbstractControl;
    readonly alwaysShowErrors = input<boolean>();
    readonly requiredLabel = input<string>();
}
